"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FavoriteMapper = void 0;
const favorite_1 = require("../models/favorite");
const forum_1 = require("../models/forum");
const mapper_1 = require("./mapper");
class FavoriteMapper {
    /**
     * Элемент избранного (mf response item):
     * [0] type, [1] id, [2] title, [3] description, [4] favFlags,
     * [5] lastPostAuthorId, [6] lastPostAuthor, [7] authorId, [8] authorName,
     * [9] lastPostTs, [10] replies, [11] notifyFlags
     */
    static mapItem(raw) {
        const type = raw[0];
        const favFlags = raw[4] || 0;
        const notifyFlags = raw[11] || 0;
        const notifyMode = notifyFlags & 3;
        const description = typeof raw[3] === 'string' ? mapper_1.PdaMapper.cleanString(raw[3]) : '';
        // Для тем (type=1) в favFlags [4] сервер кодирует и флаги избранного, и состояние темы
        // (закреплена, скрыта, закрыта и т.д.) — те же биты, что в bitmask истории (mh) и списка тем.
        const topicBitmask = type === favorite_1.FavoriteItemType.TOPIC ? (favFlags & forum_1.TOPIC_STATE_MASK) : 0;
        return {
            type,
            id: raw[1],
            title: mapper_1.PdaMapper.cleanString(raw[2]),
            description,
            topicBitmask,
            favFlags,
            lastPostAuthorId: raw[5] || 0,
            lastPostTs: mapper_1.PdaMapper.safeIsoDate(raw[9]),
            lastPostAuthorName: mapper_1.PdaMapper.cleanString(raw[6]),
            authorId: raw[7] || 0,
            authorName: mapper_1.PdaMapper.cleanString(raw[8]),
            creationDate: 0,
            repliesCount: raw[10] || 0,
            notifyFlags,
            isImportant: (favFlags & favorite_1.FavoriteFlags.IMPORTANT) !== 0,
            hasUnread: (favFlags & favorite_1.FavoriteFlags.UNREAD) !== 0,
            isPinned: (topicBitmask & forum_1.TopicFlags.PINNED) !== 0,
            isHidden: (topicBitmask & forum_1.TopicFlags.HIDDEN) !== 0,
            isClosed: (topicBitmask & forum_1.TopicFlags.CLOSED) !== 0,
            isMoved: (topicBitmask & forum_1.TopicFlags.MOVED) !== 0,
            isTopicUnread: (topicBitmask & forum_1.TopicFlags.UNREAD) !== 0,
            notifyMode,
            notifyHeader: (notifyFlags & favorite_1.FavoriteNotifyFlags.HEADER) !== 0,
        };
    }
    static mapList(data) {
        if (!Array.isArray(data))
            return [];
        return data.map((item) => this.mapItem(item));
    }
    static mapFavoritesResponse(data) {
        return {
            totalCount: data[0] || 0,
            items: this.mapList(data[1]),
        };
    }
}
exports.FavoriteMapper = FavoriteMapper;
